import {AxiosCall} from '../axios';
import {serializeQueryParams} from './PaymentHistoryService';

export const fetchReferenceData = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  type: any,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/reference-data/${type}?${queryParams}`
  );
};

export const fetchCategoryLabels = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  category_id: number
): Promise<any> => {
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/category/${category_id}/labels`
  );
};

export const fetchAnalysis = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/analysis?${queryParams}`
  );
};

export const fetchAnalysisByPatient = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  patient_id: number | string,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/patient/${patient_id}/analysis?${queryParams}`
  );
};

export const fetchHighlights = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  patient_id: number | string,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/patient/${patient_id}/highlights?${queryParams}`
  );
};

export const fetchAnalysisReminders = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  analysis_id: number | string,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/analysis/${analysis_id}/reminders?${queryParams}`
  );
};

export const fetchFullAnalysis = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  patient_id: number | string,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/patient/${patient_id}/full-analysis?${queryParams}`
  );
};

export const fetchReminders = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  options: any,
  sort?: {sort: string; order: string}
): Promise<any> => {
  let params = '';
  if (sort?.sort) {
    params = `sort_by=${sort.sort}&order=${sort.order}`;
  }
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/reminders?${queryParams}&${params}`
  );
};

export const getReminderHistoryFailedReasons = async (
  clinic_group_id: number | string,
  clinic_id: number | string
): Promise<any> => {
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/reminder-history-failed-reasons`
  );
};

export const sendReminder = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  analysis_id: number | string,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.post(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/analysis/${analysis_id}/send-reminder?${queryParams}`,
    {}
  );
};

export const ignoreMilestone = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  analysis_id: number | string,
  text: string,
  isAllMilestones: any,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.post(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/analysis/${analysis_id}/mark-as-ignore?${queryParams}`,
    {text, is_all_milestones: isAllMilestones}
  );
};

export const markMilestoneComplete = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  analysis_id: number | string,
  text: string,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  const body = {text};
  return AxiosCall.post(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/analysis/${analysis_id}/mark-as-complete?${queryParams}`,
    body
  );
};

export const fetchAnalysisMetrics = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/patient-recall/clinic-group/${clinic_group_id}/clinic/${clinic_id}/analysis/metrics?${queryParams}`
  );
};

export const sendTextReminder = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  options: any
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/patient-recall/send-reminders`,
    options
  );
};

export const systemCategories = async (): Promise<any> => {
  return AxiosCall.get(`/reference-data/patient-recall-categories`);
};

export const configureCategoriesToClinic = async (
  clinic_group_id: number,
  clinic_id: number,
  payload: any
): Promise<any> => {
  return AxiosCall.put(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/patient-recall/category`,
    payload
  );
};
